/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { v4 as uuidv4 } from 'uuid';
/* import { initMonitrace } from '@ajaltech/monitrace';


initMonitrace({
  client: 'fetch',
  endpoint: 'https://apiajaltechnology.com/api-monitrace/api/v1/errors',
  appName: 'SanetWebApp',
  version: '1.0.0',
  localFallback: true,
  userContext: () => ({
    userId: '0',
    sessionId: '0'
  })
}); */

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


const id = localStorage.getItem("sanetId");
if (id === null || id === "" || id === undefined) {
  localStorage.setItem("sanetId", uuidv4());
}
